// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"19467240","162":"dc927e09","171":"172c5390","453":"355b5c14"}[chunkId] + ".chunk.js";
};